//import Libraries
import React, { Component } from 'react';
import {connect} from 'react-redux';

//import Components
import {Container, Collapse, Row, Col, Button, Form, FormGroup, Label, Input} from 'reactstrap';

import ProductInputFormGroup from './Elements/ProductInputFormGroup';
import ProductCheckFormGroup from './Elements/ProductCheckFormGroup';
import ProductNumberFormGroup from './Elements/ProductNumberFormGroup';
import ProductTypeFormGroup from './Elements/ProductTypeFormGroup';

import * as productActions from './actions/productActions';
import * as validations from './InputValidation';

import ImageSelector from '../../../Components/ImageSelector/ImageSelector'

//import Styles
import './NewProduct.css';

class NewProduct extends Component {

    constructor(props) {
        const { mainCategory, subCategory } = props;

        super(props);
        this.state = {
            collapse : false,

            mainCategory : mainCategory,
            subCategory : subCategory,

            koName : '',
            koDescription : '',
            enName : '',
            enDescription : '',

            prices : [],
            types : [],

            file : '',
            fileValue : '',

            image : null,

            showingIndex : 0,
        }
    }

    toggleCollapse = () => {
        if(this.state.collapse) {
            this.props.makeEditDoneAnything();
            this.setState(prevState => ({
                collapse: !prevState.collapse,

                koName : '',
                koDescription : '',
                enName : '',
                enDescription : '',

                prices : [],
                types : [],

                file: '',
                fileValue : '',
                image: null,
                showingIndex : 0,
            }))
        } else {
            if(this.props.makeEditAnything()){
                this.setState(prevState => ({
                    collapse: !prevState.collapse,

                    koName : '',
                    koDescription : '',
                    enName : '',
                    enDescription : '',

                    prices : [],
                    types : [],

                    file: '',
                    fileValue : '',
                    image: null,
                    showingIndex : 0,
                }))
            }
        }
    }

    handleOnChange= (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }
    handleOnFileChange = (e) => {
        if(e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            let reader = new FileReader();
            reader.onload = (event) => {
                this.setState({
                    image : event.target.result,
                    file
                })
            }
            reader.readAsDataURL(e.target.files[0]);
        }
    }


    canRegisterProduct = ()=> {
        const {koName, koDescription, enName, enDescription, prices, types, file} = this.state;
        const koNameGood = validations.checkTextInput(koName);
        const koDescGood = validations.checkTextInput(koDescription);
        const enNameGood = validations.checkTextInput(enName);
        const enDescGood = validations.checkTextInput(enDescription);
        const fileGood = validations.checkFileInput(file);
        const pricesGood = prices.length > 0;
        const typesGood = types.length > 0;

        return (koNameGood & koDescGood && enNameGood && enDescGood && fileGood && pricesGood && typesGood);
    }

    addDefaultTypePrice = () => {
        let newPrices = [...this.state.prices];
        let newTypes = [...this.state.types];

        newPrices.push(9999);
        newTypes.push('새로운 타입');
        this.setState({
            prices : newPrices,
            types : newTypes
        })
    }

    handleOnTypeChange = (index) => {
        this.setState({
            showingIndex : index
        });
    }

    handleOnTypeTextChange = (e) => {
        let newTypes = [...this.state.types];
        newTypes[this.state.showingIndex] = e.target.value;
        this.setState({
            types : newTypes
        });
    }

    handleOnPriceTextChange = (e) => {
        let newPrices = [...this.state.prices];
        newPrices[this.state.showingIndex] = e.target.value;
        this.setState({
            prices : newPrices
        })
    } 
    handleOnRemove = (index) => {
        let newTypes = [...this.state.types];
        let newPrices = [...this.state.prices];

        newTypes.splice(index, 1);
        newPrices.splice(index, 1);
        
        this.setState({
            types : newTypes,
            prices : newPrices
        });
    }


    render() {
        const canRegister = this.canRegisterProduct();
        const productAddDiv = (
            <Row>
                <Col>
                    <div
                        className="product-add-btn"
                        onClick={this.toggleCollapse}
                    >
                        상품 추가
                    </div>
                </Col>
            </Row>
        );

        return (
            <div>
                {
                    !this.state.collapse && productAddDiv
                }
                <Collapse className="product-add-area" isOpen={this.state.collapse}>
                    <Row>
                        <Col sm="3">
                            <img className="product-image" src={this.state.image} />
                            <div className="img-editor">
                                <Input
                                    value={this.state.fileValue}
                                    type="file"
                                    name="file"
                                    id="product-img"
                                    onChange={this.handleOnFileChange}
                                    bsSize="sm"
                                />
                            </div>
                        </Col>
                        <Col className="product-form">
                            <ProductInputFormGroup 
                                label="이름"
                                type="text"
                                name="koName"
                                value={this.state.koName}
                                onChange={this.handleOnChange}
                            />
                            <ProductInputFormGroup 
                                label="설명"
                                type="text"
                                name="koDescription"
                                value={this.state.koDescription}
                                onChange={this.handleOnChange}
                            />
                        </Col>
                        <Col className="product-form">
                            <ProductInputFormGroup 
                                label="Name"
                                type="text"
                                name="enName"
                                value={this.state.enName}
                                onChange={this.handleOnChange}
                            />
                            <ProductInputFormGroup 
                                label="Description"
                                type="text"
                                name="enDescription"
                                value={this.state.enDescription}
                                onChange={this.handleOnChange}
                            />
                        </Col>
                        <Col className="product-form">
                            <ProductTypeFormGroup
                                label="종류"
                                name="selectingType"
                                onRemove={this.handleOnRemove}
                                onShowingTypeChange={this.handleOnTypeChange}
                                onAddNewDefault={this.addDefaultTypePrice}
                                onTextChange={this.handleOnTypeTextChange}
                                types={this.state.types}
                                disabled={false}
                            />
                            <ProductNumberFormGroup
                                label="가격"
                                name="price"
                                onChange={this.handleOnPriceTextChange}
                                value = {this.state.prices[this.state.showingIndex]}
                                disabled={false}
                            />
                        </Col>
                        <Col md={{ offset: 8 }}>
                            <Button
                                color={canRegister ? "primary" : "warning"}
                                onClick={() => {
                                    const { mainCategory, subCategory, koName, koDescription, enName, enDescription, prices, types, file } = this.state;
                                    
                                    let numberPrices = new Array(prices.length);
                                    for (let i = 0; i < numberPrices.length; ++i) {
                                        numberPrices[i] = Number(prices[i]);
                                    }

                                    this.props.onRegisterProduct({
                                        category : {
                                            mainCategory,
                                            subCategory
                                        },
                                        name : {
                                            ko : koName,
                                            en : enName
                                        },
                                        description : {
                                            ko : koDescription,
                                            en : enDescription,
                                        },
                                        order : this.props.numProductInSubCategory,
                                        prices : numberPrices,
                                        types : types,
                                        file 
                                    });
                                    this.toggleCollapse();
                                }}
                                disabled={!canRegister}
                                size="sm"
                                outline
                            >
                                상품등록
                                </Button>
                            <Button
                                color="danger"
                                onClick={this.toggleCollapse}
                                size="sm"
                                outline
                            >
                                등록취소
                            </Button>
                        </Col>
                    </Row> 
                </Collapse>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onRegisterProduct : (info) => {
            dispatch(productActions.registerProduct(info))
        }
    }
}

export default connect(null, mapDispatchToProps)(NewProduct);


// WEBPACK FOOTER //
// ./src/pages/Admin/ProductManager/Category/Product/NewProduct.js